// extracted by mini-css-extract-plugin
export default {"container":"ProductSearchModal_container__fQBgW"};